<script>
import TheLogin from './TheLogin';

export default {
  computed: {
    isAuthorized () {
      return this.$store.getters['auth/isAuthorized'];
    },
  },
  render () {
    if (this.isAuthorized) {
      return this.$slots.default;
    }

    return (
      <TheLogin />
    );
  },
};
</script>
